/**
 * Spinner avec branding automatique pour les formulaires publics (référent + candidat)
 */
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';
import { cn } from '@/lib/utils';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedSpinnerProps {
  branding?: BrandingSettings | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const BrandedSpinner = ({ 
  branding, 
  className,
  size = 'md'
}: BrandedSpinnerProps) => {
  const colors = useReferentBrandingColors(branding);
  
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6', 
    lg: 'h-8 w-8'
  };
  
  return (
    <div 
      className={cn(
        'animate-spin rounded-full border-b-2',
        sizeClasses[size],
        className
      )}
      style={{ borderColor: colors.primary }}
    />
  );
};